import { useEffect } from 'react';

import { useTrackExperimentExposure } from '#src/app/shared/hooks/tracking';

import { usePsfContactDecisionMakerExperiment } from './usePsfContactDecisionMakerExperiment';

/**
 * Fires the `psf_contact_decision_maker` `$exposure` once for eligible viewers.
 *
 * Eligibility (petition has a decision maker) is enforced in app code, not GrowthBook targeting, so
 * GrowthBook buckets every viewer — including ineligible ones. We therefore gate the exposure fire on
 * `eligible` here: firing off the raw resolved object unconditionally would count ineligible viewers
 * and pollute the experiment. When eligible, it fires for every arm — control included — since control
 * is the baseline arm for lift analysis. Genuine fallbacks/overrides are still suppressed by
 * `useTrackExperimentExposure` itself.
 */
export function useTrackPsfContactDecisionMakerExposure(): void {
	const { eligible, experiment } = usePsfContactDecisionMakerExperiment();
	const trackExposure = useTrackExperimentExposure(experiment);

	useEffect(() => {
		if (eligible) {
			void trackExposure();
		}
	}, [eligible, trackExposure]);
}
